<div class="container">
  <h2 class="order-section-title">Pedidos</h2>

  <div class="order-section-container">
    <order-filter></order-filter>
    <order-list></order-list>
  </div>
</div>
